<template>
    <div>
        <draggable v-model="value" :sort="true" key="456" class="imagebox">
            <div class="imgcontainer" v-for="(imgvalue, imgindex) in value"
                :style="{ width: 120 + 'px', height: 120 + 'px' }">
                <img crossorigin alt="img" :src="imgvalue">
                <div class="delimg" @click.stop="delimg(imgindex)">
                    <a-icon type="close" />
                </div>
            </div>
            <a-upload-dragger class="imgcontainer" name="file" loading style="height: 100%;"
                :style="{ width: 120 + 'px', height: 120 + 'px' }" :multiple="false" :showUploadList="false"
                :customRequest="onDrop">
                <p class="ant-upload-drag-icon" style="margin: 0;">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-hint">点击或拖拽至此上传</p>
            </a-upload-dragger>
        </draggable>
        <input type="file" id="imageInput" @change="changefile" hidden accept="image/*" />
    </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
    components: { draggable },
    props: {
        value: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            spinning: false,
            localValue: [...this.value] // 拷贝父组件的值
        }
    },
    methods: {
        delimg(index) {
            this.localValue.splice(index, 1)
            this.$emit('input', [...this.localValue])
        },
        // 处理文件拖放
        onDrop(event) {
            if (!event) return
            const isJpgOrPng = event.file.type === 'image/jpeg' || event.file.type === 'image/png' || event.file.type === 'image/jpg';
            if (!isJpgOrPng) {
                return this.$message.error('只能上传图片文件!');
            }
            const droppedFiles = event.file;
            // this.handleFiles(droppedFiles);
            this.changefile(droppedFiles)
        },
        changefile(file) {
            // const file = files[0];
            if (file) {
                // console.log("图片名称:", file);
                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     // this.imageSrc = e.target.result;
                //     this.DataList[this.imageIndex].value.push(e.target.result)
                // };
                // reader.readAsDataURL(file);
                const formData = new FormData();
                formData.append('file', file);
                this.spinning = true
                this.$http({
                    url: '/admin/sys/upload',
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data', // 告诉服务器上传的是文件
                    },
                    data: formData
                }).then(res => {
                    this.localValue.push(res.data.url)
                    this.$emit('input', [...this.localValue])
                })
            } else {
                console.log("未选择图片");
            }
            document.getElementById('imageInput').value = '';
        },
    }
}
</script>
<style scoped lang="scss">
.imagebox {
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;

    .imgcontainer {
        width: 100px;
        height: 100px;
        background: #FFF;
        margin: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        position: relative;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .delimg {
            position: absolute;
            width: 25%;
            height: 25%;
            background: red;
            color: #FFF;
            right: 5%;
            top: 5%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 100%;
            font-weight: bold;
        }
    }
}
</style>